import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useAuth } from "@/lib/auth";

export function ProtectedRoute() {
  const { user, loading } = useAuth();
  const location = useLocation();
  if (loading) {
    return (
      <div className="min-h-screen grid place-items-center bg-background" data-testid="auth-loading">
        <div className="overline animate-pulse">Loading workspace</div>
      </div>
    );
  }
  if (!user && !location.state?.user) return <Navigate to="/login" replace />;
  return <Outlet />;
}
